// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AccountCryptonym extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  guid!: string;
  /** Int32 FK account */
  accountId!: number;
  /** DateTimeOffset */
  crtnTs!: Date;
  /** DateTime */
  expirationDate?: Date;
  /** FK accountId */
  account!: Account;
}

